import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";
import Project from "./Project";
import Project2 from "./Project2";

function Work() {
  return (
    <div className="work container-fluid">
      <div className="container work__container">
        <div className="row">
          <div className="col-md-12 work__title">
            <h4>02.</h4>
            <h3>Some Unique things I have built.</h3>
            <span></span>
          </div>
        </div>
        <Project2
          link="https://new-designnft.netlify.app/"
          title="Crypto Nfts"
          technologies="React,  Blockchain, Solidity, Web3.js , Ether.js"
          img="./img/projects/crypto.png"
          description="Nft minting dapp project with blockchain smart-contract integration for a client on fiverr.It is a decentralized smart-contract based project.It has a smart-contract that mints Nfts and a dapp that renders the Nfts."
        />

        <Project
          link="https://united-insurance.netlify.app/"
          title="United Insurance"
          technologies="React, Redux, Formik, Context-Api"
          img="./img/projects/united.png"
          description="It is a freelancing project for a client based in lahore.Currently it is in beta version.It has 20+ pages with multiple step forms.We are a team of 2 developers working on this project "
        />

        <Project2
          link="https://apocalypticats.io/"
          title="Apocalypticats Nfts"
          technologies=" React , Ether.js , Web3.js , Framer.js"
          img="./img/projects/apoc.png"
          description="It is a decentralized smart-contract based project runninig on the cardano blockchain. From domain,hosting to developing everthing done from the ground up by me ."
        />

        <Project
          link="https://airbnb-khan-git-main-saud-app.vercel.app/"
          title="Airbnb Clone"
          technologies=" Next.Js, React,  Map-Box, Vercel"
          img="./img/projects/Airbnb.png"
          description="A real-time clone of Airbnb powered by Next js (SSR).  It is completely responsive.  It has a search functunality with a search page that renders data form an api.  It got a real time map in the destinations."
        />

        <Project2
          link="https://saud-khanfb.netlify.app/"
          title="Facebook Clone"
          technologies="React, Firebase, HTML, CSS"
          img="./img/projects/fb.png"
          description="A beautiful  facebook clone made with the help of clever programmer/yt. It has a reat time post functionality and is powered by firebase google authenticaiton .  Anyone can sign in using google authentication."
        />
        <Project
          link="https://www.mshealthcareinternational.com/"
          title="MS HealthCare"
          technologies="Wordpress , Woocommerce "
          img="./img/projects/health.png"
          description="A wordpress project with Woocommerce integration . From domain, hosting to developing everthing done from the ground up by me ."
        />
        <Project2
          link="https://pigeons-nft.netlify.app/"
          title="Pigeons Nfts"
          technologies="React , Framer , Web3.js , Ether.js , Solidity"
          img="./img/projects/pigeon.png"
          description="Nft minting dapp project with blockchain smart-contract integration for a client on fiverr.It is a decentralized smart-contract based project.It has a smart-contract that mints Nfts and a dapp that renders the Nfts."
        />
      </div>
    </div>
  );
}

export default Work;
